<div class="residence-list-container">
  <div class="list-letters" *ngIf="residencesLoaded()">
    <span
      *ngFor="let letterGroup of letterGroups"
      class="list-letter-group"
      (click)="selectList(letterGroup)"
      [class.current]="isSelected(letterGroup)"
      [class.empty]="!isSelectable(letterGroup)"
      >{{ letterGroup }}</span
    >
  </div>
  <p *ngIf="!residencesLoaded()" class="loading-residences">
    Loading Accommodation list...
  </p>
  <div class="results-list" *ngIf="currentList() as currentList">
    <li
      *ngFor="let residence of currentList"
      (click)="selectResidence(residence)"
    >
      {{ residence.name }}
    </li>
  </div>
  <p
    *ngIf="residencesLoaded() && !(currentList()?.length)"
    class="no-residences"
  >
    {{ noResidencesFoundForLetterMessage }}
  </p>
  <p class="add-links" *ngIf="residencesLoaded()">
    <a (click)="doPrivateLet()">I have a private let or rental</a>
    <a (click)="doLivingAtHome()">I'm living at home</a>
  </p>
</div>
